import React from 'react' // required to have jsx/html elements

export const ListContractsFailed = 'ListContractsFailed'
export const CreateContractFailed = 'CreateContractFailed'
export const ActivateContractFailed = 'ActivateContractFailed'
export const CreateContractSuccess = 'CreateContractSuccess'
export const GetContractFailed = 'GetContractFailed'
export const ActivateContractSuccess = 'ActivateContractSuccess'
export const SellerLookupFailed = 'SellerLookupFailed'

export const FlashMessages = {
    [ListContractsFailed]: () => ({
        type: 'error',
        header: 'Failed to list contracts',
        content: <span>Refresh the page. If the issue persists, <a target="_blank" rel="noopener noreferrer" href="https://t.corp.amazon.com/create/templates/bdd8072e-aab0-4949-8d03-7eb5dc5b17be">cut us a ticket</a>.</span>
    }),
    [CreateContractFailed]: () => ({
        type: 'error',
        header: 'Failed to create contract',
        content: <span>Please try again. If the issue persists, <a target="_blank" rel="noopener noreferrer" href="https://t.corp.amazon.com/create/templates/bdd8072e-aab0-4949-8d03-7eb5dc5b17be">cut us a ticket</a>.</span>
    }),
    [ActivateContractFailed]: () => ({
        type: 'error',
        header: 'Failed to activate contract',
        content: <span>Please try again. If the issue persists, <a target="_blank" rel="noopener noreferrer" href="https://t.corp.amazon.com/create/templates/bdd8072e-aab0-4949-8d03-7eb5dc5b17be">cut us a ticket</a>.</span>
    }),
    [CreateContractSuccess]: () => ({
        type: 'success',
        header: 'Successfully created new contract'
    }),
    [GetContractFailed]: () => ({
        type: 'error',
        header: 'Failed to get contract',
        content: <span>Refresh the page. If the issue persists, <a target="_blank" rel="noopener noreferrer" href="https://t.corp.amazon.com/create/templates/bdd8072e-aab0-4949-8d03-7eb5dc5b17be">cut us a ticket</a>.</span>
    }),
    [ActivateContractSuccess]: () => ({
        type: 'success',
        header: 'Successfully activated contract',
        content: <span>This contract is now visible to customers.</span>
    }),
    [SellerLookupFailed]: () => ({
        type: 'error',
        header: 'Failed to get seller information',
        content: <span>Please verify the account ID is corrent and try again. If the issue persists, <a target="_blank" rel="noopener noreferrer" href="https://t.corp.amazon.com/create/templates/bdd8072e-aab0-4949-8d03-7eb5dc5b17be">cut us a ticket</a>.</span>
    })
}


// WEBPACK FOOTER //
// ./src/components/FlashMessage/FlashMessageConstants.jsx